export const UI_SYSTEM = 'UI';

export const UPDATE_INVENTORY_VIA_POPUP = 'update-inventory-via-popup';
export const UPDATE_INVENTORY_VIA_FILE_UPLOAD = 'update-inventory-via-file-upload';
export const INVENTORY_PAGE_SKU_BUFFER_FILTER = 'inventory-page-sku-buffer-filter';
export const INVENTORY_PAGE_DEFAULT_BUFFER_FILTER = 'inventory-page-default-buffer-filter';
export const CHANGE_BUFFER_BY_SKU = 'change-buffer-by-sku';
